import { Button } from '~/shared/ui/Buttons'
import {
  Description,
  Wrapper,
  TitleWrapper,
  Title,
  Img,
  ButtonWrapper,
} from './styled'

export function SuccessStep() {
  return (
    <Wrapper>
      <TitleWrapper>
        <Title>Ваши данные обрабатываются</Title>
        <Description>Это может занять до 30 минут</Description>
        <Description>
          Дождитесь обработки данных после этого вы сможете арендовать
          автомобиль
        </Description>
      </TitleWrapper>

      <Img src='/images/Success.png' alt='' />

      <ButtonWrapper>
        <Button
          fullWidth
          variant='limeFlooded'
          size='large'
          to='/'
          style={{ marginBottom: '12px' }}
        >
          На главную
        </Button>

        <Button
          fullWidth
          variant='lightSteelBlueBorder'
          size='large'
          to='/booking-cars'
        >
          Вернуться к каталогу
        </Button>
      </ButtonWrapper>
    </Wrapper>
  )
}
